export default __webpack_public_path__ + "static/media/walker_feed.0656e0df.WEBP";